class ProductSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slidesWrapper = this.querySelector('.slideshow-wrapper');
    this.slides = Array.from(this.querySelectorAll('.product-slideshow-slide'));
    this.dots = this.querySelectorAll('.product-pagination-dot');
    this.totalSlides = this.slides.length;
    this.currentSlide = 0;

    // Navigation elements
    this.prevBtn = this.querySelector('.product-slideshow-arrow--prev');
    this.nextBtn = this.querySelector('.product-slideshow-arrow--next');
    this.paginationContainer = this.querySelector('.product-slideshow-pagination');

    // Bindings
    this.nextSlide = this.nextSlide.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.handleDotClick = this.handleDotClick.bind(this);
  }

  init() {
    if (this.totalSlides < 2) {
        if(this.prevBtn) this.prevBtn.style.display = 'none';
        if(this.nextBtn) this.nextBtn.style.display = 'none';
        return;
    }

    // Generate Dots
    if (this.paginationContainer) {
        this.paginationContainer.innerHTML = '';
        this.slides.forEach((_, index) => {
            const dot = document.createElement('button');
            dot.classList.add('product-pagination-dot');
            if (index === this.currentSlide) dot.classList.add('active');
            dot.dataset.index = index;
            dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
            dot.addEventListener('click', this.handleDotClick);
            this.paginationContainer.appendChild(dot);
        });
        this.dots = this.paginationContainer.querySelectorAll('.product-pagination-dot');
    }

    // Arrow Event Listeners
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.prevSlide);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.nextSlide);

    // Initial State
    this.updateSlider();
  }

  connectedCallback() {
      if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.subscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }
      this.init();
  }

  removeListeners() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.prevSlide);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.nextSlide);
      if (this.dots) {
          this.dots.forEach(dot => dot.removeEventListener('click', this.handleDotClick));
      }
  }

  disconnectedCallback() {
      this.removeListeners();
      if (this.subscriber) {
          this.subscriber();
      }
  }

  handleVariantChange(event) {
      if (!event.data || !event.data.html) return;
      
      const sectionId = event.data.sectionId;
      if (!this.closest(`[id="MainProduct-${sectionId}"]`)) return;

      const html = event.data.html;
      const newSlideshow = html.querySelector('product-slideshow');
      
      if (newSlideshow) {
          // Clean up old listeners before replacing content
          this.removeListeners();

          this.innerHTML = newSlideshow.innerHTML;
          this.slidesWrapper = this.querySelector('.slideshow-wrapper');
          this.slides = Array.from(this.querySelectorAll('.product-slideshow-slide'));
          this.dots = this.querySelectorAll('.product-pagination-dot'); // Will be empty initially
          this.totalSlides = this.slides.length;
          this.currentSlide = 0;
          
          this.prevBtn = this.querySelector('.product-slideshow-arrow--prev');
          this.nextBtn = this.querySelector('.product-slideshow-arrow--next');
          this.paginationContainer = this.querySelector('.product-slideshow-pagination');

          this.init(); // Re-bind events and generate dots
      }
  }

  updateSlider() {
    const translateX = -(this.currentSlide * 100);
    this.slidesWrapper.style.transform = `translateX(${translateX}%)`;
    this.slidesWrapper.style.transition = 'transform 0.5s ease-in-out';

    // Update Dots
    this.dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // Update Arrows Visibility
    if (this.prevBtn) {
        this.prevBtn.style.display = this.currentSlide === 0 ? 'none' : 'flex';
    }
    if (this.nextBtn) {
        this.nextBtn.style.display = this.currentSlide === this.totalSlides - 1 ? 'none' : 'flex';
    }
  }

  nextSlide() {
    if (this.currentSlide < this.totalSlides - 1) {
      this.currentSlide++;
      this.updateSlider();
    }
  }

  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
      this.updateSlider();
    }
  }

  handleDotClick(e) {
    const index = parseInt(e.target.dataset.index);
    this.currentSlide = index;
    this.updateSlider();
  }
}

// Define the Web Component
customElements.define('product-slideshow', ProductSlideshow);
